import { ADD_HSN, DELETE_HSN, GET_HSN, UPDATE_HSN, GET_ONE_HSN} from "../types";
  
  const initialState = { list: [], single: null };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_HSN:
        return { ...state, list: payload };
  
      case UPDATE_HSN:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_HSN:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_HSN:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };

      case GET_ONE_HSN:
        return { ...state, single: payload };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  